var _ellipse, _path, _path2, _ellipse2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNicLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5293,
    cy: 20.7429,
    rx: 20.5866,
    ry: 20.0964,
    fill: "#00A6B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95447 10.5492L15.0009 39.859C20.022 41.2939 24.5411 40.3374 27.0516 39.859L39.1023 10.0674C27.0516 -6.31537 8.47347 1.8815 3.95447 10.5492Z",
    fill: "#030E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0184 13.3906L15.0015 39.8591C19.4201 41.4276 26.55 40.8394 27.0522 39.8591L21.5289 18.7824L27.5543 16.8217L19.0184 13.3906Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.8262,
    cy: 16.1348,
    rx: 0.803379,
    ry: 0.784251,
    fill: "#030E60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0184 8.48828H15.0015L19.0184 11.9194V8.48828Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNicLogo);
export default __webpack_public_path__ + "static/media/nicLogo.be03473f5077aceea9241e2b9c618e45.svg";
export { ForwardRef as ReactComponent };